import PropTypes from 'prop-types';
import useLiterals from 'utils/hooks/useLiterals';
import Spinner from 'react-bootstrap/Spinner';
import './styles.scss';

const Select = (props) => {
  const {
    label = '',
    value = '',
    options = [],
    name = '',
    required = false,
    className = '',
    autoComplete = '',
    placeholder = '',
    error = '',
    disabled = false,
    canBeEmpty = true,
    loading = false,
    onChange,
  } = props;

  const literals = useLiterals('select');

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={`ui-input ui-select ${className} ${label ? 'has-label' : ''} ${loading ? 'loading' : ''}`}>
      {label && (
        <label htmlFor={name} className='mb-1'>
          {label}
          {required && '*'}
        </label>
      )}
      <div className='ui-select-container'>
        <select
          id={name || undefined}
          required={required}
          value={value}
          onChange={handleChange}
          name={name}
          className={`form-control ${error ? 'is-invalid' : ''}`}
          placeholder={placeholder}
          autoComplete={autoComplete}
          disabled={disabled || loading}
        >
          {(canBeEmpty || !value) && (
            <option
              value=''
              style={!canBeEmpty ? { display: 'none' } : {}}
              disabled={!canBeEmpty}
            >
              {`- ${(loading && literals.common.loading) || placeholder || label || literals.selectOneOption}${required ? '*' : ''} -`}
            </option>
          )}
          {options.map((option, index) => (
            <option key={option.value || index} value={option.value}>{option.label}</option>
          ))}
        </select>

        <label className='chevron'>
          {loading && <Spinner animation='border' role='status' variant='primary' />}
        </label>
      </div>
      {error && (
        <div className='invalid-feedback'>
          {error}
        </div>
      )}
    </div>
  );
};

Select.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  label: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  autoComplete: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  canBeEmpty: PropTypes.bool,
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default Select;
